module.exports = __webpack_public_path__ + "static/media/boss-attack-student.baa826d1.png";